<div>
    <ng-select #pselector class="aa-ng-select input-field ng-select-heigth-50vh"
               (change)="onChange()"
               [items]="periods"
               [searchable]="false"
               [clearable]="true"
               [groupBy]="groupByFn"
               [groupValue]="groupValueFn"
               [(ngModel)]="value"
               [placeholder]="'CMDB.ASSETS.EXPORT.PERIODPLACEHOLDER' | translate">
        <ng-template ng-optgroup-tmp
                     let-grp="item">
            <div class="item-optgroup">
                <i class="fad fa-calendar-alt"></i>{{ grp.year }}
            </div>
        </ng-template>
        <ng-template ng-label-tmp
                     let-period="item">
            <div class="item-label">
                {{period.name}} <span>{{ period.details }}</span>
            </div>
        </ng-template>
        <ng-template ng-option-tmp
                     let-period="item">
            <div>{{ period.name }}</div>
            <div class="period-details">{{ period.details }}</div>
        </ng-template>
    </ng-select>
</div>
